<template>
    <form-row :title="title">
        <div class="flex-1 -mt-4 sm:mt-0">
            <div class="flex flex-col sm:flex-row">
                <div class="mt-2 sm:mt-0 sm:col-gap-1 flex-1">
                    <input-text
                        :name="'contacts[' + field + ']' + index_for_array + '[name]'"
                        v-model="contact.name"
                        label="Name"
                        placeholder="Name"
                        :read_only="read_only"
                    />
                </div>

                <div class="mt-2 sm:mt-0 sm:col-gap-1 flex-1">
                    <input-text
                        :name="'contacts[' + field + ']' + index_for_array + '[email]'"
                        v-model="contact.email"
                        label="Email"
                        placeholder="Email"
                        :read_only="read_only"
                    />
                </div>

                <div class="mt-2 sm:mt-0 sm:col-gap-1 flex-1">
                    <input-text
                        :name="'contacts[' + field + ']' + index_for_array + '[phone]'"
                        v-model="contact.phone"
                        label="Phone"
                        placeholder="Phone"
                        :read_only="read_only"
                    />
                </div>
            </div>

            <send-notifications
                v-if="! read_only && ! is_lite"
                :name="'contacts[' + field + ']' + index_for_array + '[receives_notifications]'"
                v-model="contact.receives_notifications"
            />
        </div>
    </form-row>
</template>

<script>
import SendNotifications from './send-notifications.vue';

export default {
    components: {
        SendNotifications,
    },

    props: {
        field: {},
        contact: { default: () => ({}) },
        title: { default: '' },
        index: {},
        read_only: { default: false },
        is_lite: { default: false },
    },

    computed: {
        index_for_array() {
            return this.index != null ? '[' + (this.index + 1) + ']' : '';
        },
    },
}
</script>
